import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BwAutocompleteComponent } from './bw-autocomplete/bw-autocomplete.component';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../material/material.module';

@NgModule({
  declarations: [
    BwAutocompleteComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule
  ],
  exports: [
    BwAutocompleteComponent
  ]
})
export class ComponentsModule {}